<template>
  <div class="edit-popin">
    <div
      v-if="workspace === workspaceTypes.personal || workspace === workspaceTypes.organization"
      class="edit-action"
      @click.stop="updateLabels(resume)"
    >
      <Pen class="edit-icon small" />
      {{ $t('dashboard.editAction.label') }}
    </div>
    <div v-if="workspace === workspaceTypes.personal" class="edit-action" @click.stop="moveResumes(resume)">
      <Slide class="edit-icon" />
      {{ $t('dashboard.editAction.move') }}
    </div>
    <div
      v-if="workspace === workspaceTypes.personal || workspace === workspaceTypes.organization"
      class="edit-action mobile"
      @click.stop="duplicate(resume)"
    >
      <Sheet class="edit-icon small" />
      {{ $t('dashboard.editAction.duplicate') }}
    </div>
    <div
      v-if="workspace === workspaceTypes.personal || workspace === workspaceTypes.organization"
      class="edit-action"
      @click.stop="share(resume)"
    >
      <Share class="edit-icon small" />
      {{ $t('dashboard.editAction.share') }}
    </div>
    <div
      v-if="workspace === workspaceTypes.personal || workspace === workspaceTypes.organization"
      class="edit-action"
      @click.stop="remove(resume)"
    >
      <Bin class="edit-icon small" />
      {{ $t('dashboard.editAction.delete') }}
    </div>
    <div v-if="workspace === workspaceTypes.shared" class="edit-action unfollow" @click.stop="unshared(resume)">
      <Unfollow class="edit-icon small" />
      {{ $t('dashboard.editAction.unfollow') }}
    </div>
  </div>
</template>

<script>
import enums from '@/helpers/enums';

import Sheet from '@/assets/listing/sheet.svg';
import Bin from '@/assets/listing/bin.svg';
import Share from '@/assets/listing/share.svg';
import Slide from '@/assets/listing/slide.svg';
import Unfollow from '@/assets/listing/unfollow.svg';
import Pen from '@/assets/listing/pen.svg';

export default {
  name: 'EditPopin',
  components: {
    Sheet,
    Bin,
    Share,
    Slide,
    Unfollow,
    Pen,
  },
  props: {
    workspace: {
      type: Number,
      required: true,
    },
    resume: {
      type: Object,
      required: true,
    },
  },
  emits: ['updateLabels', 'moveResumes', 'duplicate', 'share', 'remove', 'unshared'],
  data() {
    return {
      workspaceTypes: enums.workspaceTypes,
    };
  },
  methods: {
    updateLabels(resume) {
      this.$emit('updateLabels', resume);
    },
    moveResumes(resume) {
      this.$emit('moveResumes', resume);
    },
    duplicate(resume) {
      this.$emit('duplicate', resume);
    },
    share(resume) {
      this.$emit('share', resume);
    },
    remove(resume) {
      this.$emit('remove', resume);
    },
    unshared(resume) {
      this.$emit('unshared', resume);
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/popins.scss';
</style>
